/**
 * Profiling the application
 */
class Profiling {
    /**
     * Constructor
     * @param active
     */
    constructor(active) {
        this.active = active;
        this.timers = {};
    }

    /**
     * Start profiling
     * @param {string} tag
     * @param {string|null} id
     */
    start(tag, id) {
        if (this.active) {
            if (id === null) {
                id = "General";
            }
            this.timers[id + '_' + tag] = {
                start: new Date()
            };
        }
    }

    /**
     * Stop profiling
     * @param {string} tag
     * @param {string|null} id
     */
    end(tag, id) {
        if (this.active) {
            if (id === null) {
                id = "General";
            }
            const timer = this.timers[id + '_' + tag];
            if (timer) {
                timer.end = new Date();
                timer.result = (timer.end - timer.start);
            }
        }
    }

    /**
     * Report profiling data
     */
    report() {
        if (this.active) {
            var names = Object.keys(this.timers);
            var sortedNames = names.sort();

            var div = document.createElement("div");
            div.style.position = 'absolute';
            div.style.bottom = 0;
            div.style.right = 0;
            div.style.width = "900px";
            div.style.height = "300px";
            div.style.border = "1px solid black";
            div.style.background = "white";
            div.style.overflow = "scroll";
            div.style.padding = "5px";
            var h3 = document.createElement("h3");
            h3.innerHTML = "Uploader Profiling Report";
            div.appendChild(h3);
            var lastId = "";
            for (var i = 0; i < sortedNames.length; i++) {
                if (this.timers[sortedNames[i]].hasOwnProperty("result")) {
                    var keys = sortedNames[i].split('_');
                    var id = keys[0];
                    var tag = keys[1];


                    if (id !== lastId) {
                        lastId = id;
                        var h4 = document.createElement("h4");
                        h4.innerHTML = lastId;
                        div.appendChild(document.createElement('br'));
                        div.appendChild(h4);
                    }

                    var reportElement = document.createElement("div");
                    reportElement.innerHTML = tag + ": " + (this.timers[
                        sortedNames[i]].result / 1000) + "s";
                    div.appendChild(reportElement);
                }
            }

            //Averages
            var h4 = document.createElement("h4");
            h4.innerHTML = "Averages";
            div.appendChild(document.createElement('br'));
            div.appendChild(h4);
            var tagsAveraged = [];
            for (var i = 0; i < sortedNames.length; i++) {
                if (this.timers[sortedNames[i]].hasOwnProperty("result")) {
                    var keys = sortedNames[i].split('_');
                    var tag = keys[1];
                    if (!tagsAveraged.indexOf(tag) > -1) {
                        var average = this._average(tag);

                        var reportElement = document.createElement("div");
                        reportElement.innerHTML = tag + ": " + (average / 1000) + "s";
                        div.appendChild(reportElement);
                        tagsAveraged.push(tag);
                    }
                }
            }
            document.getElementsByTagName("body")[0].appendChild(div);
        }
    }

    /**
     * Calculate average
     * @private
     * @param {string} tag
     * @returns {number}
     */
    _average(tag) {
        var times = [];
        var keys = Object.keys(this.timers);
        for (var i = 0; i < keys.length; i++) {
            if (this.timers[keys[i]].hasOwnProperty("result")) {
                var split = keys[i].split('_');
                var itemTag = split[1];
                if (tag === itemTag) {
                    times.push(this.timers[keys[i]].result);
                }
            }
        }
        return times.reduce((p, c) => p + c, 0) / times.length;
    }
}

module.exports = Profiling;
